
(() => {
  const CODE = 'MAKEITADOUBLE';
  const isPairCode = code => [CODE, 'APPRVEDPAIR49-EBA60367'].includes(String(code).toUpperCase());
  const KEY = 'apprved-pair-unconfirmed';

  const currency = () => window.Shopify?.currency?.active || document.documentElement.dataset.currency || 'USD';
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:currency()}).format(cents / 100);
  function quote(first, second = first) {
    const local = currency() !== 'USD';
    const rate = local ? Number(window.Shopify?.currency?.rate) : 1;
    const full = Number(first) + Number(second);
    if (!(full > 0) || !(rate > 0)) return {totalCents:null,estimated:false,total:'Calculated in bag', saving:'Pair savings', full:full > 0 ? money(full) : '', note:'Exact bundle price and savings are confirmed in your bag.'};
    const saving = Math.min(Number(first), Number(second));
    return {totalCents:full-saving,estimated:local,total:(local ? '≈ ' : '') + money(full - saving), saving:(local ? '≈ ' : '') + money(saving), full:money(full), note:local ? 'Estimated in ' + currency() + '. Exact bundle total and savings are confirmed in your bag.' : 'Black Friday savings apply automatically in your bag.'};
  }
  function paintOffers(root = document) {
    root.querySelectorAll('[data-pair-local-price]').forEach((el) => {
      const q = quote(Number(el.dataset.pairLocalPrice));
      el.querySelectorAll('[data-pair-total]').forEach(n => { n.textContent = q.total; });
      el.querySelectorAll('[data-pair-saving]').forEach(n => { n.textContent = q.saving; });
      el.querySelectorAll('[data-pair-full]').forEach(n => { n.textContent = q.full; });
      el.querySelectorAll('[data-pair-note]').forEach(n => { n.textContent = q.note + ' Shipping and taxes shown at checkout.'; });
    });
  }

  let busy = false;
  let unconfirmed = null;
  const root = () => window.Shopify?.routes?.root || '/';
  const isShop = () => /(^|\.)apprved\.com$|^rzx7rf-gi\.myshopify\.com$/.test(location.hostname);
  const remember = (token) => { unconfirmed = token; try { token ? sessionStorage.setItem(KEY, token) : sessionStorage.removeItem(KEY); } catch { /* Keep the in-memory confirmation marker. */ } };
  const remembered = () => { try { return unconfirmed || sessionStorage.getItem(KEY); } catch { return unconfirmed; } };
  const ownLines = (cart, token) => cart.items.filter((line) => line.properties?._apprved_pair === token);
  const eligibleLine = (line) => line.options_with_values?.some((option) => /colou?r/i.test(option.name) && /^(black|white)$/i.test(option.value));
  const manualCodes = (cart) => (cart.discount_codes || []).filter((code) => code.applicable !== false).map((code) => code.code);
  async function request(path, data, accept = 'application/json') {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(root() + path, {
        method: data ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
        headers: { Accept: accept, ...(data ? { 'Content-Type': 'application/json' } : {}) },
        ...(data ? { body: JSON.stringify(data) } : {}), signal: controller.signal
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Your bag could not be updated.');
      return result;
    } finally { clearTimeout(timeout); }
  }
  async function removeAttempt(token) {
    let cart = await request('cart.js');

    while (ownLines(cart, token).length) {
      await request('cart/change.js', { id: ownLines(cart, token)[0].key, quantity: 0 });
      cart = await request('cart.js');
    }
    return cart;
  }
  function verifyDiscount(cart) {
    const lines = cart.items.filter(eligibleLine);
    const prices = lines.flatMap(line => Array(line.quantity).fill(line.original_price)).sort((a,b)=>a-b);
    const freeCount = Math.min(3, Math.floor(prices.length / 2));
    const expected = prices.slice(0, freeCount).reduce((a,b)=>a+b,0);
    const allocations = lines.flatMap(line => line.line_level_discount_allocations || []);
    const saving = allocations.filter(a => /Black Friday/i.test(a.discount_application?.title || '')).reduce((sum,a)=>sum+Number(a.amount),0);
    return cart.currency === currency() && freeCount > 0 && saving === expected;
  }
  async function applyOffer(cart) {
    if (manualCodes(cart).some(isPairCode)) return request('cart/update.js', {discount:manualCodes(cart).filter(code=>!isPairCode(code)).join(',')});
    return request('cart.js');
  }
  async function add(picks) {
    if (busy) throw new Error('Your pair is already being added. Please wait.');
    if (!isShop()) throw new Error('This local design preview cannot purchase. Open the Shopify preview to add your pair.');
    busy = true;
    let token, before;
    try {
      const pending = remembered();
      if (pending) {
        const cart = await request('cart.js');
        if (ownLines(cart, pending).length) throw new Error('A previous pair may already be in your bag. Open your bag to check before adding again.');
        remember(null);
      }
      if (!Array.isArray(picks) || ![2,4,6].includes(picks.length) || picks.some(pick => !pick.product?.handle || !pick.variant?.available || !(Number(pick.variant.price) > 0) || !/^(black|white)$/i.test(pick.variant.color))) throw new Error('Choose an available color and size for every tee.');
      before = await request('cart.js');
      if (before.currency !== currency()) throw new Error('Your currency changed. Refresh this page before adding your pair.');
      if (manualCodes(before).some(code => !isPairCode(code))) throw new Error('Your bag already has another discount. The pair offer cannot combine with it. Open your bag to choose which offer to use.');
      if ((before.cart_level_discount_applications || []).some((discount) => Number(discount.total_allocated_amount) > 0) || before.items.some((line) => !eligibleLine(line) && line.original_line_price > line.final_line_price)) throw new Error('Another offer is already saving you money on other items. The pair offer cannot combine with it. Open your bag to review those items first.');
      if (before.items.filter(eligibleLine).reduce((n,line)=>n+line.quantity,0)+picks.length > 6) throw new Error('This offer includes up to six tees per order. Review your bag before adding another bundle.');
      const fresh = await Promise.all([...new Set(picks.map((pick) => pick.product.handle))].map(async (handle) => [handle, await request(`products/${encodeURIComponent(handle)}.js`)]));
      for (const pick of picks) {
        const product = fresh.find(([handle]) => handle === pick.product.handle)?.[1];
        const variant = product?.variants.find((candidate) => String(candidate.id) === String(pick.variant.id));
        const colorIndex = product?.options.findIndex((option) => /colou?r/i.test(option.name ?? option));
        if (!variant?.available || Number(variant.price) !== Number(pick.variant.price) || colorIndex < 0 || !/^(black|white)$/i.test(variant.options[colorIndex])) throw new Error('A selected tee has changed or is unavailable. Please choose its color and size again.');
      }
      token = `pair-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      remember(token);
      const items = [];
      for (const pick of picks) {
        const existing = items.find((item) => item.id === Number(pick.variant.id));
        if (existing) existing.quantity += 1;
        else items.push({ id: Number(pick.variant.id), quantity: 1, properties: { _apprved_pair: token } });
      }
      try { await request('cart/add.js', { items }); }
      catch (error) {
        const cart = await request('cart.js');
        if (ownLines(cart, token).reduce((sum, line) => sum + line.quantity, 0) !== picks.length) throw error;

      }
      const cart = await applyOffer(await request('cart.js'));
      if (ownLines(cart, token).reduce((sum, line) => sum + line.quantity, 0) !== picks.length || !verifyDiscount(cart)) throw new Error('The pair discount could not be confirmed. Your new pair has not been kept in the bag.');

      for (const line of before.items) {
        const match = cart.items.find((item) => item.id === line.id && JSON.stringify(item.properties || {}) === JSON.stringify(line.properties || {}) && JSON.stringify(item.selling_plan_allocation || null) === JSON.stringify(line.selling_plan_allocation || null));
        if (!match || match.quantity !== line.quantity) throw new Error('Your bag changed while adding this pair. Please review it before continuing.');
      }
      remember(null);
      return cart;
    } catch (error) {
      if (token) {
        try {
          const cart = await removeAttempt(token);

          if (before && !manualCodes(before).includes(CODE) && manualCodes(cart).includes(CODE)) await request('cart/update.js', { discount: manualCodes(before).join(',') });
          remember(null);
        } catch {
          throw new Error('We could not confirm the last cart update. Open your bag before trying again; your previous items have not been cleared.');
        }
      }
      throw error;
    } finally { busy = false; }
  }
  const canComplete = cart => !!cart && cart.item_count === 1 && cart.items.length === 1 && cart.items[0].quantity === 1 && eligibleLine(cart.items[0]) && cart.currency === currency() && cart.total_discount === 0 && cart.items[0].original_price > 0 && !manualCodes(cart).some(code => !isPairCode(code));
  const completionVariants = (cart, product) => canComplete(cart) && product?.variants ? product.variants.filter(variant => variant.available && Number(variant.price) > 0 && /^(black|white)$/i.test(variant.color)) : [];
  async function completeSingle(pick) {
    if (busy) throw new Error('checkout_offer_busy');
    if (!isShop()) throw new Error('checkout_offer_preview');
    busy = true;
    let token, before;
    try {
      const pending = remembered();
      if (pending) {
        const cart = await request('cart.js');
        if (ownLines(cart, pending).length) throw new Error('checkout_offer_pending');
        remember(null);
      }
      before = await request('cart.js');
      if (!canComplete(before) || !completionVariants(before, pick.product).some(variant => String(variant.id) === String(pick.variant?.id))) throw new Error('checkout_offer_changed');
      const fresh = await request(`products/${encodeURIComponent(pick.product.handle)}.js`);
      const variant = fresh.variants.find(candidate => String(candidate.id) === String(pick.variant.id));
      const colorIndex = fresh.options.findIndex(option => /colou?r/i.test(option.name ?? option));
      if (!variant?.available || Number(variant.price) !== Number(pick.variant.price) || colorIndex < 0 || !/^(black|white)$/i.test(variant.options[colorIndex])) throw new Error('checkout_offer_stock');
      token = `single-${Date.now()}-${Math.random().toString(36).slice(2,10)}`;
      remember(token);
      try { await request('cart/add.js', {items:[{id:Number(variant.id),quantity:1,properties:{_apprved_pair:token}}]}); }
      catch (error) {
        const cart = await request('cart.js');
        if (ownLines(cart,token).reduce((sum,line) => sum + line.quantity,0) !== 1) throw error;
      }
      const cart = await applyOffer(await request('cart.js'));
      const original = before.items[0];
      const preserved = cart.items.find(line => String(line.variant_id) === String(original.variant_id) && JSON.stringify(line.properties || {}) === JSON.stringify(original.properties || {}) && JSON.stringify(line.selling_plan_allocation || null) === JSON.stringify(original.selling_plan_allocation || null));
      if (cart.item_count !== 2 || ownLines(cart,token).reduce((sum,line) => sum + line.quantity,0) !== 1 || !preserved || preserved.quantity !== 1 || !verifyDiscount(cart)) throw new Error('checkout_offer_error');
      remember(null);
      return cart;
    } catch (error) {
      if (token) {
        try {
          const cart = await removeAttempt(token);
          if (before && !manualCodes(before).some(code => code.toUpperCase() === CODE) && manualCodes(cart).some(code => code.toUpperCase() === CODE)) await request('cart/update.js',{discount:manualCodes(before).join(',')});
          remember(null);
        } catch { throw new Error('checkout_offer_review'); }
      }
      throw error;
    } finally { busy = false; }
  }

  let catalogPromise;
  async function catalog(refresh = false) {
    if (refresh) catalogPromise = null;
    if (!catalogPromise) catalogPromise = (async () => {
      const result = [];
      if (!isShop()) return (window.APPRVED_CATALOG || []).filter(p => p.variants?.some(v => v.available && /^(black|white)$/i.test(v.color)));
      let page = 1, pages = 1;
      do {
        const data = await request(`collections/all?view=apprved-pair-data&page=${page}`, undefined, 'text/html');
        if (!Array.isArray(data.products) || !Number.isInteger(data.pages) || data.pages < 1) throw new Error('The second-tee list could not load. Please close and reopen the pair picker.');
        pages = data.pages;
        for (const product of data.products) {
          const variants = product.variants.filter(v => v.available && Number(v.price) > 0 && /^(black|white)$/i.test(v.color));
          if (variants.length) result.push({...product, variants, price: Math.min(...variants.map(variant => Number(variant.price))), image: product.images?.[0] || variants[0].image, url: root() + 'products/' + encodeURIComponent(product.handle)});
        }
        page++;
      } while (page <= pages);
      return [...new Map(result.map(p => [p.handle,p])).values()].sort((a,b) => a.title.localeCompare(b.title));
    })().catch(error => { catalogPromise = null; throw error; });
    return catalogPromise;
  }
  window.APPRVED_PAIR_CART = { add, completeSingle, canComplete, completionVariants, catalog, cartUrl: () => root() + 'cart', verifyDiscount, quote, money, paintOffers };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => paintOffers()); else paintOffers();
  document.addEventListener('shopify:section:load', () => paintOffers());
  const watchOffers = () => new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) {
      if (node.nodeType !== 1) continue;
      paintOffers(node.matches('[data-pair-local-price]') ? node.parentElement : node);
    }
  }).observe(document.body, {childList:true,subtree:true});
  if (document.body) watchOffers(); else document.addEventListener('DOMContentLoaded',watchOffers);
})();

